<template>
    <section>
        <sy-baselist
                hideAdd
                hideOperate
                :filters="filters"
                 :autoSearch="false"
                 :fixWhere="fixWhere"
                listUrl="server/business/Performance.ashx?cmd=GetRecordList"
        >
            <el-table-column prop="PerformanceUserName" label="绩效用户" width="120" sortable>
            </el-table-column>
            <el-table-column prop="FPerformance" label="绩效" width="400" sortable>
            </el-table-column>
             <el-table-column prop="FNote" label="备注" width="400" sortable>
            </el-table-column>
            <el-table-column prop="FCreateTime" label="时间" :formatter="formatDate2" width="200" sortable>
            </el-table-column>
        
        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
                filters: [
                    {type: "date",name:"FCreateTime",text:"时间", value: null}
                ],
                fixWhere:''
            }
        },
        methods:{
         _initrecord(userId){
                this.fixWhere = "FUserId="+userId;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Performance_Record.vue